export enum InformationDialogs {
  COMMUNICATION_NEW_PAGE_CLIENT_ADD,
  COMMUNICATION_NEW_PAGE_CLIENT_FILE,
  CONTRACT_CUPS_ALREADY_ASSOCIATED,
  CONTRACT_ACTIVE_CUPS_ALREADY_ASSOCIATED,
  CONTRACT_INACTIVE_CUPS_ALREADY_ASSOCIATED,
  CONTRACT_DATES_NOT_SELECTED,
  CONTRACT_ATR_FUTURE_VERSION_EXISTS,
  FLEXIBILITIES_LIMITS_CONFIG_ERROR,
  FLEXIBILITIES_SUBTYPE_CONFIG_ERROR,
  PENDING_SAVE,
  PENDING_DELETE,
  PROCEDURE_CONTRACT_NOT_VALID,
  PROCEDURE_PRODUCTS_MISSING,
  PROCEDURE_CNAE_MISSING,
  PRICE_COMPONENT_CREATE_ERROR,
  TANKS_DATE_CHANGED_MESSAGE,
  CONTRACT_ATR_NOT_ACTIVE,
  CANNOT_GENERATE_INVOICE,
  PREVENT_FROM_DELETE_LAST_PRODUCT_CONTRACT,
  PREVENT_FROM_ESCAPING_WITHOUT_SAVE,
  INVOICE_CYCLES_CONFIRM_DELETE,
  MISSING_SUPPLY_POINT,
  LIMIT_QUERY_RESULTS,
  LIMIT_QUERY_RESULTS_SEARCHFILTER,
  INVOICE_CYCLE_ISSUE_ALREADY_ISSUED_ALL,
  LEAD_EVALUATE_MIXED_SELECTION,
  LEAD_PUBLISH_MIXED_SELECTION,
  PENDING_MOD_REQUEST
}
